import api from "../services/api";

import { IKit, IPedido, ISearchRequest, ISearchResponse } from "../interfaces";

export interface IOrderListModel {
    id?: string;
    status: number;
    codigo: number;
    gerenteRegional: string;
    gerenteSetor: string;
    representante: string;
    acerto: string;
    liberacao: number;
}

export interface IOrderPostModel {
    acerto: string;
    gerenteRegionalId: string;
    gerenteSetorId?: string;
    representanteId?: string;
    status: number;
}

interface IOrderInsertRequest {
    orderPostModel: IOrderPostModel;
    kits: IKit[];
}

interface IOrderResponse {
    pedido: IPedido;
    message: string;
}

export interface IOrderPutModel {
    acerto: string;
    gerenteSetorId: string;
    representanteId: string;
    status: number;
}

export interface IOrderPutModelLiberacao {
    liberacao: number;
}

export interface IOrderUpdateRequest {
    id: string;
    orderPutModel: IOrderPutModel;
    kits: IKit[];
}

export interface IOrderUpdateRequestLiberacao {
    id: string;
    orderPutModelLiberacao: IOrderPutModelLiberacao;
}

class OrderRepository {

    public List = async (searchRequest: ISearchRequest): Promise<ISearchResponse<IOrderListModel>> => {

        const response = await api.get<ISearchResponse<IOrderListModel>>("pedido", {
            params: {
                search: searchRequest.search,
                filter: searchRequest.filter,
                pagenumber: searchRequest.pageNumber,
                recordsbypage: searchRequest.recordsByPage
            }
        });

        return response.data;
    }

    public Insert = async ({ orderPostModel, kits }: IOrderInsertRequest): Promise<IOrderResponse> => {
        const responsePedido = await api.post<IOrderResponse>("pedido", orderPostModel);

        const { id, representanteId } = responsePedido.data.pedido;

        let kitsToUpdate: IKit[] = [];

        kits.map(kit =>
            kitsToUpdate.push({
                ...kit,
                pedidoId: id,
                statusKit: representanteId !== null ? 2 : 1
            })
        );

        await api.put("kit/range", kitsToUpdate );

        return responsePedido.data;
    }

    public Update = async ({ id, orderPutModel, kits }: IOrderUpdateRequest): Promise<IOrderResponse> => {
        const response = await api.put<IOrderResponse>(`pedido/${id}`, orderPutModel);

        const { representanteId } = response.data.pedido;

        let kitsToUpdate: IKit[] = [];

        kits.map(kit =>
            kitsToUpdate.push({
                ...kit,
                pedidoId: id,
                statusKit: representanteId !== null ? 2 : 1
            })
        );

        await api.put("kit/range", kitsToUpdate );

        return response.data;
    }

    public UpdateLiberacao = async ({ id, orderPutModelLiberacao }: IOrderUpdateRequestLiberacao): Promise<IOrderResponse> => {
        const response = await api.put<IOrderResponse>(`pedido/${id}/liberar`, orderPutModelLiberacao);
        return response.data;
    }
   
    public GetById = async (id: string): Promise<IPedido> => {
        const response = await api.get<IPedido>(`pedido/${id}`);

        return response.data;
    }
}

const orderRepository = new OrderRepository();
export default orderRepository;
